import { isActiveRoute, useRoute } from '@trello/router';
import { RouteId } from '@trello/router/routes';

import { useCardShortLinkForBoardIdQuery } from './CardShortLinkForBoardIdQuery.generated';
import { useTrelloBoardObjectIdByShortLinkQuery } from './TrelloBoardObjectIdByShortLinkQuery.generated';

/**
 * Will get the object id for the board based on the route you are on
 * @returns object id for board
 */
export const useBoardIdFromBoardOrCardRoute = () => {
  const route = useRoute<typeof RouteId.BOARD | typeof RouteId.CARD>();

  // Currently, we can't pass in the shortLink to useFragment. Once Apollo
  // supports that, we can migrate this to useFragment.
  // eslint-disable-next-line @trello/no-cache-only-queries
  const { data: trelloBoardData } = useTrelloBoardObjectIdByShortLinkQuery({
    variables: {
      shortLink: isActiveRoute(route, RouteId.BOARD)
        ? route.params.shortLink
        : '',
    },
    skip: !isActiveRoute(route, RouteId.BOARD),
    fetchPolicy: 'cache-only',
    waitOn: ['TrelloCurrentBoardInfo'],
  });
  const trelloBoardObjectId =
    trelloBoardData?.trello.boardByShortLink?.objectId;

  // eslint-disable-next-line @trello/no-cache-only-queries
  const { data: cardData } = useCardShortLinkForBoardIdQuery({
    variables: {
      cardId: isActiveRoute(route, RouteId.CARD) ? route.params.shortLink : '',
    },
    skip: !isActiveRoute(route, RouteId.CARD),
    fetchPolicy: 'cache-only',
    waitOn: ['PreloadCard'],
  });

  return trelloBoardObjectId ?? cardData?.card?.idBoard ?? null;
};
